import { useTranslation } from 'libs/i18n';
import { Stack, Typography } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import { SettingsContentStyled } from 'modules/settings/common/components';

import { NotificationSettingsTable } from './NotificationSettingsTable';

const ContentStyled = styled(SettingsContentStyled)(() => ({
  gridTemplateColumns: '1fr 2fr 1fr',
}));

export const NotificationsSettings = () => {
  const { t } = useTranslation();

  return (
    <ContentStyled>
      <Stack justifyContent="space-between" spacing={8}>
        <Typography variant="bodyBold">
          {t('settings.notifications.title')}
        </Typography>
        <Typography>{t('settings.notifications.subtitle')}</Typography>
      </Stack>
      <NotificationSettingsTable />
    </ContentStyled>
  );
};
